import { Box, Button, Link, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import Iconify from "minimals-template/components/Iconify"
import { useCreateSkillMap } from "./use-create-skill-map"
import illustrationSrc from "./skill_mapping_empty.svg"

export function SkillMappingsEmpty({ status, archivedCount, onViewArchived, onViewActive, canManageOptimiser }) {
    const handleCreate = useCreateSkillMap()
    // Archived filter with no archived items: offer a way back to Active rather than the "create your first" state
    const isArchivedView = status === "archived"
    const archivedNoun = archivedCount === 1 ? "item" : "items"

    return (
        <Stack data-cy="skill-mappings-empty" alignItems="center" justifyContent="center" spacing={2} sx={{ py: 4 }}>
            <Box component="img" src={illustrationSrc} sx={{ width: 275, height: 200 }} />
            <Stack spacing={0.5} alignItems="center">
                <Typography variant="h6">
                    <If value={isArchivedView}>
                        No archived skill mappings
                        <Else>No skill mappings yet</Else>
                    </If>
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, textAlign: "center" }}>
                    <If value={isArchivedView}>
                        There are no archived skill mappings.
                        <Else>Assign SFG20 maintenance skills to trades so regimes can be costed accurately</Else>
                    </If>
                </Typography>
            </Stack>
            <If value={isArchivedView}>
                <Button variant="outlined" startIcon={<Iconify icon="mdi:arrow-left" />} onClick={onViewActive}>
                    Back to Active
                </Button>
                <Else>
                    <If value={canManageOptimiser}>
                        <Button variant="contained" startIcon={<Iconify icon="mdi:plus" />} onClick={handleCreate}>
                            Create Mapping
                        </Button>
                    </If>
                    <If value={archivedCount > 0}>
                        <Typography variant="body2" color="text.secondary">
                            You have {archivedCount} archived {archivedNoun}
                            {" - "}
                            <Link component="button" variant="body2" onClick={onViewArchived}>
                                view archived
                            </Link>
                        </Typography>
                    </If>
                </Else>
            </If>
        </Stack>
    )
}
